import request from './request';
// let BaseUrl = 'http://192.168.11.242:8181/';
let BaseUrl = 'https://www.bceia.cn/';
// let BaseUrl = '';
// zhang 获取banner图
export function getBanner(params) {
    return request({
        url: BaseUrl + 'pc/banner/lists',
        method: 'get',
        params
    })
}
// zhang 获取企业展示数据
export function getCompanyLists(params) {
    return request({
        url: BaseUrl + 'pc/banner/companyLists',
        method: 'get',
        params
    })
}

// zhang 获取精彩回顾数据
export function getListCate(params) {
    return request({
        url: BaseUrl + 'pc/file/listCate',
        method: 'get',
        params
    })
}

// zhang 获取合作媒体数据
export function getMediaLists(params) {
    return request({
        url: BaseUrl + 'pc/banner/mediaLists',
        method: 'get',
        params
    })
}

// zhang 首页资讯数据
export function getArticle(params) {
    return request({
        url: BaseUrl + 'pc/article/lists',
        method: 'get',
        params
    })
}

// zhang 关于展会
export function sessionHpLists(params) {
    return request({
        url: BaseUrl + '/pc/content/sessionHpLists',
        method: 'get',
        params
    })
}

// zhang 资料下载
export function getFileList(params) {
    return request({
        url: BaseUrl + '/pc/file/lists',
        method: 'get',
        params
    })
}
// zhang 展商列表
export function getCompanyList(params) {
    return request({
        url: BaseUrl + '/pc/company/lists',
        method: 'get',
        params
    })
}

// zhang 届次数据
export function getSessionList(params) {
    return request({
        url: BaseUrl + '/pc/session/lists',
        method: 'get',
        params
    })
}
// zhang 展商详情
export function geCompanyDetail(params) {
    return request({
        url: BaseUrl + '/pc/company/detail',
        method: 'get',
        params
    })
}
// zhang 获取产品类型
export function getproductType(params) {
    return request({
        url: BaseUrl + '/pc/productType/lists',
        method: 'get',
        params
    })
}

// zhang 获取产品展示类别
export function getshowType(params) {
    return request({
        url: BaseUrl + '/pc/showType/lists',
        method: 'get',
        params
    })
}

// zhang 获取产品列表
export function getproductList(params) {
    return request({
        url: BaseUrl + '/pc/product/lists',
        method: 'get',
        params
    })
}
// zhang 获取企业招聘
export function getcompanyRecruitList(params) {
    return request({
        url: BaseUrl + '/pc/companyRecruit/lists',
        method: 'get',
        params
    })
}

// zhang 获取产品详情
export function getproductDetail(params) {
    return request({
        url: BaseUrl + '/pc/product/detail',
        method: 'get',
        params
    })
}
// zhang 新闻详情接口
export function getNewsDetail(params) {
    return request({
        url: BaseUrl + '/pc/article/detail',
        method: 'get',
        params
    })
}
// zhang 展会概况详情接口
export function getSessionHpdetail(params) {
    return request({
        url: BaseUrl + '/pc/content/sessionHpdetail',
        method: 'get',
        params
    })
}
// zhang 招聘详情接口
export function getcompanyRecruit(params) {
    return request({
        url: BaseUrl + '/pc/companyRecruit/detail',
        method: 'get',
        params
    })
}

// zhang 参展流程接口
export function getProcessLists(params) {
    return request({
        url: BaseUrl + '/pc/content/processLists',
        method: 'get',
        params
    })
}
 // zhang 联系我们接口
export function getContactsLists(params) {
    return request({
        url: BaseUrl + '/pc/content/contactsLists',
        method: 'get',
        params
    })
}

 // zhang  展会服务
 export function getBuilderLists(params) {
    return request({
        url: BaseUrl + '/pc/exhibitionServe/lists',
        method: 'get',
        params
    })
}
// zhang  资料下载分类

export function getlistCate(params) {
    return request({
        url: BaseUrl + '/pc/file/listCate',
        method: 'get',
        params
    })
}

export function getfileDetail(params) {
    return request({
        url: BaseUrl + '/pc/file/detail',
        method: 'get',
        params
    })
}

//zhang 展会日程
export function getcalendarLists(params) {
    return request({
        url: BaseUrl + '/pc/content/calendarLists',
        method: 'get',
        params
    })
}
// banner 详情 内链 zhang
export function getbannerdetail(params) {
    return request({
        url: BaseUrl + '/pc/banner/detail',
        method: 'get',
        params
    })
}
//zhang 获取网站信息
export function getWebsite(params) {
    return request({
        url: BaseUrl + '/api/pc/config',
        method: 'get',
        params
    })
}

//zhang 获取网站信息
export function getWebMenu(params) {
    return request({
        url: BaseUrl + '/pc/webMenu/lists',
        method: 'get',
        params
    })
}

//dxm 获取国家地区
export function getLocationTree(params) {
    return request({
        url: BaseUrl + '/pc/locations/getLocationTree',
        method: 'get',
        params
    })
}

//dxm 参展申请提交
export function companyApply(data) {
    return request({
        url: BaseUrl + '/pc/CompanyApply/add',
        method: 'post',
        data
    })
}

//zhang 参展申请企业类型 展示范围接口
export function getdict(params) {
    return request({
        url: BaseUrl + '/adminapi/config/dict',
        method: 'get',
        params
    })
}

//zhang 参展申请 获取验证码
export function getCode(data) {
    return request({
        url: BaseUrl + '/api/sms/sendCode',
        method: 'post',
        data
    })
}

export function getApplicationIndustry(params) {
    return request({
        url: BaseUrl + '/pc/applicationIndustry/lists?page_type=0',
        method: 'get',
        params
    })
}

export function getExhibitionScope(params) {
    return request({
        url: BaseUrl + '/pc/exhibition_scope/lists?page_type=0',
        method: 'get',
        params
    })
}





//图片上传
// export function upImg(data) {
//     return request({
//         url: BaseUrl + 'kindeditor/php/uploadApi.php?mode=3',
//         method: 'post',
//         data
//     })
// }




